import { render, staticRenderFns } from "./menuItem.component.vue?vue&type=template&id=a7abdcd8&scoped=true&"
import script from "./menuItem.component.vue?vue&type=script&lang=js&"
export * from "./menuItem.component.vue?vue&type=script&lang=js&"
import style0 from "./menuItem.component.vue?vue&type=style&index=0&id=a7abdcd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7abdcd8",
  null
  
)

export default component.exports